/**
 * Insufficient Credits Modal
 * Global modal component — shows credit packs for quick purchase
 */

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useModalStore } from '@/store/useModalStore'
import { api } from '@/services/api'
import '@/assets/styles/components/insufficient-credits-modal.css'

const creditPacks = [
  { id: 'pack-small', credits: 6000, price: 9.9 },
  { id: 'pack-large', credits: 30000, price: 49.9 },
]

export const InsufficientCreditsModal: React.FC = () => {
  const navigate = useNavigate()
  const { isOpen, currentBalance, closeModal } = useModalStore()
  const [selectedPack, setSelectedPack] = useState(creditPacks[0].id)
  const [loading, setLoading] = useState(false)

  if (!isOpen) return null

  const current = creditPacks.find((p) => p.id === selectedPack)!

  const handlePurchase = async () => {
    setLoading(true)
    try {
      const resp = await api.payment.createSession(selectedPack)
      if (resp.success && resp.checkout_url) {
        window.location.href = resp.checkout_url
      }
    } catch (error) {
      console.error('Failed to create checkout session:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleViewPlans = () => {
    closeModal()
    navigate('/app/pricing')
  }

  const handleClose = () => {
    closeModal()
  }

  return (
    <div className="icm-overlay" onClick={handleClose}>
      <div className="icm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button className="icm-close" onClick={handleClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Header */}
        <h3 className="icm-title">Get more credits</h3>
        <p className="icm-subtitle">
          Your balance: <strong>{currentBalance.toLocaleString()}</strong> credits
        </p>

        {/* Pack selector */}
        <div className="icm-packs">
          {creditPacks.map((pack) => (
            <button
              key={pack.id}
              className={`icm-pack ${selectedPack === pack.id ? 'icm-pack--active' : ''}`}
              onClick={() => setSelectedPack(pack.id)}
            >
              <span className="icm-pack-credits">{pack.credits.toLocaleString()}</span>
              <span className="icm-pack-label">credits</span>
            </button>
          ))}
        </div>

        {/* Price display */}
        <div className="icm-price">
          <span className="icm-price-currency">$</span>
          <span className="icm-price-amount">{current.price}</span>
        </div>
        <p className="icm-price-note">{current.credits.toLocaleString()} credits · one-time purchase</p>

        {/* Purchase button */}
        <button className="icm-buy-btn" onClick={handlePurchase} disabled={loading}>
          {loading ? 'Redirecting…' : `Purchase ${current.credits.toLocaleString()} credits`}
        </button>

        {/* Link to pricing page */}
        <button className="icm-link" onClick={handleViewPlans}>
          View subscription plans
        </button>
      </div>
    </div>
  )
}

export default InsufficientCreditsModal
